export default function locale(state = null, action = {}) {
  if (action.type === 'LOCALE') {
    return action.locale
  }
  return state
}
